package com.siriusxm.pia.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

/**
 * A standard content area wrapper that applies the primary content padding and width styles.
 * When [fixedHeight] is true, the content area will fill its parent using flex layout,
 * enabling fixed-height child layouts like split-panel views.
 */
@Composable
fun primaryContentArea(fixedHeight: Boolean = false, content: @Composable () -> Unit = {}) {
    Div({
        classes(ServiceViewStyles.primaryContent)
        if (fixedHeight) {
            style {
                flex(1)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                minHeight(0.px)
            }
        }
    }) {
        content()
    }
}
